/* Progressive enhancement only; Shopify's localization POST owns market routing. */
(() => {
  'use strict';

  const controllerKey = Symbol.for('pf.market-selector.20261008');
  if (window[controllerKey]) return;

  const selector = '.pf-market-selector__form';
  const states = new WeakMap();
  let pending = null;

  const availableCountry = (select, value) => {
    if (!/^[A-Z]{2}$/.test(value || '')) return false;
    return Array.from(select.options).some((option) =>
      option.value === value && !option.disabled &&
      !(option.parentElement?.tagName === 'OPTGROUP' && option.parentElement.disabled)
    );
  };

  const returnPath = () => {
    try {
      const href = window.location.href;
      if (/[\u0000-\u0020\u007f\\]/.test(href)) return null;
      const url = new URL(href);
      if (!['http:', 'https:'].includes(url.protocol) ||
          url.origin !== window.location.origin || url.username || url.password) return null;
      if (!url.pathname.startsWith('/') || url.pathname.startsWith('//') ||
          /%2f|%5c/i.test(url.pathname)) return null;
      for (const key of Array.from(url.searchParams.keys())) {
        if (['country', 'currency'].includes(key.toLowerCase())) url.searchParams.delete(key);
      }
      if (/\/products\/[^/]+\/?$/.test(url.pathname)) {
        const variant = document.querySelector('[data-ps-product] [data-ps-variant-input]')?.value;
        if (typeof variant === 'string' && /^[1-9][0-9]*$/.test(variant) && variant.trim() === variant) {
          url.searchParams.set('variant', variant);
        }
      }
      const path = url.pathname + url.search + url.hash;
      return new URL(path, url.origin).origin === url.origin ? path : null;
    } catch (_) {
      return null;
    }
  };

  const setReturnPath = (form, path) => {
    let field = form.querySelector('[name="return_to"]');
    if (field && (field.tagName !== 'INPUT' || field.type !== 'hidden')) {
      throw new Error('Unsupported localization return field');
    }
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      form.appendChild(field);
    }
    field.value = path;
  };

  const useFallback = (state) => {
    state.enhanced = false;
    state.form.removeAttribute('data-pf-market-enhanced');
    state.select.removeEventListener('change', state.onChange);
    state.form.removeEventListener('submit', state.onSubmit);
    if (pending === state) pending = null;
  };

  const enhance = (form) => {
    if (states.has(form)) return;
    const select = form.querySelector('[name="country_code"]');
    if (!select || select.tagName !== 'SELECT' ||
        typeof form.requestSubmit !== 'function' || !returnPath()) return;

    const initial = [window.PFMarket?.country,
      Array.from(select.options).find((option) => option.defaultSelected)?.value,
      select.value].find((value) => availableCountry(select, value));
    if (!initial) return;

    const state = { form, select, initial, enhanced: false, submitEvent: null };
    state.onSubmit = (event) => {
      if (event.target === form && pending === state) state.submitEvent = event;
    };
    state.onChange = () => {
      if (!state.enhanced || pending || select.disabled ||
          !availableCountry(select, select.value) || select.value === initial) return;
      try {
        const path = returnPath();
        if (!path) throw new Error('Unsafe localization return path');
        setReturnPath(form, path);
        pending = state;
        state.submitEvent = null;
        form.requestSubmit();
        // Constraint validation or another handler can cancel submission.
        if (!state.submitEvent || state.submitEvent.defaultPrevented) pending = null;
      } catch (_) {
        useFallback(state);
      }
    };
    states.set(form, state);
    try {
      form.addEventListener('submit', state.onSubmit);
      select.addEventListener('change', state.onChange);
      state.enhanced = true;
      form.setAttribute('data-pf-market-enhanced', 'true');
    } catch (_) {
      useFallback(state);
    }
  };

  const initialize = (scope) => {
    if (scope.matches?.(selector)) enhance(scope);
    scope.querySelectorAll?.(selector).forEach(enhance);
  };
  const onReady = () => initialize(document);
  const onSectionLoad = (event) => initialize(event.target);
  const onPageShow = () => {
    pending = null;
    initialize(document);
    document.querySelectorAll(selector).forEach((form) => {
      const state = states.get(form);
      if (!state) return;
      state.submitEvent = null;
      state.select.value = state.initial;
    });
  };

  // Install lifecycle recovery before hiding any fallback button.
  try {
    window.addEventListener('pageshow', onPageShow);
    document.addEventListener('shopify:section:load', onSectionLoad);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } catch (_) {
    window.removeEventListener('pageshow', onPageShow);
    document.removeEventListener('shopify:section:load', onSectionLoad);
    document.removeEventListener('DOMContentLoaded', onReady);
    return;
  }
  window[controllerKey] = true;
  if (document.readyState !== 'loading') onReady();
})();
